import { Component, OnInit, Input, TemplateRef, ContentChild } from '@angular/core';

@Component({
    selector: 'tab-page',
    templateUrl: './tab-page.component.html',
    styleUrls: ['./tab-page.component.scss'],
    standalone: false
})
export class TabPageComponent {
    @ContentChild(TemplateRef) public template: TemplateRef<any>;
    @Input() public title: string = '';

    constructor() { }
}
